import _objectDestructuringEmpty from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "play-data"
};
var _hoisted_2 = {
  class: "solt-title"
};
var _hoisted_3 = {
  class: "solt-title"
};
var _hoisted_4 = {
  class: "solt-title"
};
var _hoisted_5 = {
  class: "solt-title"
};
var _hoisted_6 = {
  class: "solt-title"
};
var _hoisted_7 = {
  class: "solt-title"
};
var _hoisted_8 = {
  class: "solt-title"
};
var _hoisted_9 = {
  class: "mar-r"
};
var _hoisted_10 = {
  class: "mar-r"
};
var _hoisted_11 = {
  class: "mar-r"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  key: 1,
  class: "empty-box"
};
import topSearch from './components/topSearch.vue';
import viewAllDialog from './components/viewAllDialog.vue';
import { MessagePlugin } from 'tdesign-vue-next';
/** ui组件库 */
import { MessagePlugin as message } from 'tdesign-vue-next';
import { HelpCircleIcon } from 'tdesign-icons-vue-next';
/** 表头 */
import { interactDataTableHeader } from './const/interactData.js';
/** 组合式api */
import { ref, reactive, nextTick } from 'vue';
/** 接口 */
import { getList } from '@/api/index-jiao.js';
import { appAliasInfo } from '@/utils/auth';
export default {
  __name: 'Play',
  setup: function setup(__props) {
    /** 组件 */
    var tableHeight = ref('calc(100vh - 276px)');
    var hasData = ref(false);
    var getAuth = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$appAliasInfo, hasAuth, menus, index;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return appAliasInfo('classReports');
            case 1:
              _yield$appAliasInfo = _context.v;
              hasAuth = _yield$appAliasInfo.hasAuth;
              menus = _yield$appAliasInfo.menus;
              if (hasAuth && menus) {
                index = menus.findIndex(function (itm) {
                  return itm.path === '/classInteractData';
                });
                hasData.value = index > -1;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getAuth() {
        return _ref.apply(this, arguments);
      };
    }();
    getAuth();
    var getTableHeight = function getTableHeight() {
      nextTick(function () {
        var _document$getElements;
        var topSearchHeight = ((_document$getElements = document.getElementsByClassName('top-search')[0]) === null || _document$getElements === void 0 ? void 0 : _document$getElements.clientHeight) || 0;
        // console.log(topSearchHeight, '---topSearchHeight')
        tableHeight.value = "calc(100vh - ".concat(topSearchHeight, "px - 194px)");
      });
    };
    var debounce = function debounce(fn, delay) {
      var timer;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          fn();
        }, delay);
      };
    };
    var useDebounce = debounce(getTableHeight, 300);
    window.addEventListener('resize', useDebounce);

    /** 初始化相关_方法 */
    var getData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, newData, res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              tableLoading.value = true;
              data = _objectSpread(_objectSpread({}, searchForm.value), {}, {
                current: pageObj.current,
                size: pageObj.size
              });
              newData = Object.assign({}, (_objectDestructuringEmpty(data), data));
              _context2.p = 1;
              _context2.n = 2;
              return getList(newData);
            case 2:
              res = _context2.v;
              pageObj.total = res.data.data.total;
              tableData.value = res.data.data.records || [];
              tableData.value.forEach(function (i) {
                i.dealTeachingTimeCount = "".concat(i.teachingTimeCount || '', " ").concat(i.classHour || '');
                i.selfDefineSubjecl = searchForm.value.subjectDictItemName;
                i.selfDefineGrade = searchForm.value.showGradeName;
                i.newCoverData = [];
                i.versionRate.forEach(function (it) {
                  i.newCoverData.push("V".concat(it.version, " \u5360\u6BD4:").concat(it.rate, " \u8BBE\u5907\u6570:").concat(it.schoolCount));
                });
              });
              if (data.subjectDictItemName && !data.classGrade) {
                tableColumns.value = interactDataTableHeader.filter(function (i) {
                  return i.show === true || i.title === '学科';
                });
              } else if (!data.subjectDictItemName && data.classGrade) {
                tableColumns.value = interactDataTableHeader.filter(function (i) {
                  return i.show === true || i.title === '年级';
                });
              } else if (data.subjectDictItemName && data.classGrade) {
                tableColumns.value = interactDataTableHeader.filter(function (i) {
                  return i.show === true || i.title === '学科' || i.title === '年级';
                });
              } else {
                tableColumns.value = interactDataTableHeader.filter(function (i) {
                  return i.show === true;
                });
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              (_t === null || _t === void 0 ? void 0 : _t.message) && MessagePlugin.warning(_t === null || _t === void 0 ? void 0 : _t.message);
            case 4:
              _context2.p = 4;
              tableLoading.value = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }));
      return function getData() {
        return _ref2.apply(this, arguments);
      };
    }();

    /** 初始化相关 */
    var pageObj = reactive({
      current: 1,
      size: 20,
      total: 0
    });
    var tableColumns = ref([]);
    tableColumns.value = interactDataTableHeader.filter(function (i) {
      return i.show === true;
    });
    var tableData = ref([]);
    var searchForm = ref({}); // 查询参数
    var viewVisible = ref(false); // 查看全部弹窗显隐
    var tableRow = ref({}); // 点击项行信息
    var tableLoading = ref(false);
    // getData() // 获取列表数据_首次已在条件筛选查询中调用

    /** 事件相关 */
    /**
     * 改变当前页码或每页数据条数
     */
    var changeSizeOrCurrent = function changeSizeOrCurrent(val) {
      pageObj.current = val.current;
      pageObj.size = val.pageSize;
      getData();
    };

    /**
     * 查询
     */
    var handleSearch = function handleSearch(form) {
      searchForm.value = form;
      pageObj.current = 1;
      pageObj.size = 20;
      getData();
      getTableHeight();
    };

    /**
     * 查看全部
     */
    var changeViewVisible = function changeViewVisible(bool) {
      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      viewVisible.value = bool;
      tableRow.value = row;
    };
    return function (_ctx, _cache) {
      var _component_t_tooltip = _resolveComponent("t-tooltip");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_table = _resolveComponent("t-table");
      var _component_t_pagination = _resolveComponent("t-pagination");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [hasData.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(topSearch, {
        class: "top-search",
        onHandleSearch: handleSearch
      }), _createVNode(_component_t_table, {
        rowKey: "schoolId",
        loading: tableLoading.value,
        columns: _unref(tableColumns),
        data: tableData.value,
        height: tableHeight.value,
        class: "table-box"
      }, {
        "title-teaching": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createTextVNode(" 授课次数 ", -1)), _createVNode(_component_t_tooltip, {
            content: "使用互动课堂上课的次数"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(HelpCircleIcon), {
                class: "tips"
              })];
            }),
            _: 1
          })])];
        }),
        "teaching-time": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_3, [_cache[3] || (_cache[3] = _createTextVNode(" 授课总时长（分钟） ", -1)), _createVNode(_component_t_tooltip, {
            content: "使用互动课堂上课的累计时长，从开始上课到下课记为单次时长"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(HelpCircleIcon), {
                class: "tips"
              })];
            }),
            _: 1
          })])];
        }),
        "course-count": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_4, [_cache[4] || (_cache[4] = _createTextVNode(" 演示学程数 ", -1)), _createVNode(_component_t_tooltip, {
            content: "在互动课堂大屏端演示过几个学程的数量，相同条件下对相同的学程去重"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(HelpCircleIcon), {
                class: "tips"
              })];
            }),
            _: 1
          })])];
        }),
        "course-number": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_5, [_cache[5] || (_cache[5] = _createTextVNode(" 演示学程次数 ", -1)), _createVNode(_component_t_tooltip, {
            content: "在互动课堂中大屏端演示了多少次学程，演示一次计数一次"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(HelpCircleIcon), {
                class: "tips"
              })];
            }),
            _: 1
          })])];
        }),
        "title-show-count": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_6, [_cache[6] || (_cache[6] = _createTextVNode(" 展示数 ", -1)), _createVNode(_component_t_tooltip, {
            content: "在互动课堂中有提交作品的展板数，无学生提交作品的展板不计数"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(HelpCircleIcon), {
                class: "tips"
              })];
            }),
            _: 1
          })])];
        }),
        "title-push-count": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_7, [_cache[7] || (_cache[7] = _createTextVNode(" 文件推送数 ", -1)), _createVNode(_component_t_tooltip, {
            content: "在互动课堂中大屏端和教师端推送给学生的文件总数"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(HelpCircleIcon), {
                class: "tips"
              })];
            }),
            _: 1
          })])];
        }),
        "broadcast-count": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_8, [_cache[8] || (_cache[8] = _createTextVNode(" 广播大屏次数 ", -1)), _createVNode(_component_t_tooltip, {
            content: "在互动课堂中大屏端点击“广播”并成功开启广播大屏的次数"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(HelpCircleIcon), {
                class: "tips"
              })];
            }),
            _: 1
          })])];
        }),
        operate: _withCtx(function (_ref3) {
          var _row$versionRate$, _row$versionRate$2, _row$versionRate$3;
          var row = _ref3.row;
          return [row.versionRate.length ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("span", _hoisted_9, _toDisplayString("V".concat(row === null || row === void 0 || (_row$versionRate$ = row.versionRate[0]) === null || _row$versionRate$ === void 0 ? void 0 : _row$versionRate$.version)), 1), _createElementVNode("span", _hoisted_10, "占比：" + _toDisplayString(row === null || row === void 0 || (_row$versionRate$2 = row.versionRate[0]) === null || _row$versionRate$2 === void 0 ? void 0 : _row$versionRate$2.rate), 1), _createElementVNode("span", _hoisted_11, "设备数：" + _toDisplayString(row === null || row === void 0 || (_row$versionRate$3 = row.versionRate[0]) === null || _row$versionRate$3 === void 0 ? void 0 : _row$versionRate$3.schoolCount), 1), _createElementVNode("span", {
            class: "blue-text",
            onClick: function onClick($event) {
              return changeViewVisible(true, row);
            }
          }, "查看全部", 8, _hoisted_12)], 64)) : _createCommentVNode("", true)];
        }),
        empty: _withCtx(function () {
          return [_createVNode(_component_svg_icon, {
            name: "empty-table",
            size: "120"
          })];
        }),
        _: 1
      }, 8, ["loading", "columns", "data", "height"]), _createVNode(_component_t_pagination, {
        modelValue: pageObj.current,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return pageObj.current = $event;
        }),
        pageSize: pageObj.size,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = function ($event) {
          return pageObj.size = $event;
        }),
        total: pageObj.total,
        pageSizeOptions: [20, 50, 100, 200, 500],
        "show-jumper": "",
        class: "page-fixed",
        onChange: changeSizeOrCurrent
      }, null, 8, ["modelValue", "pageSize", "total"])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_Empty, {
        icon: require('@/assets/discuss/empty.png'),
        text: "当前尚无课堂报告互动数据权限"
      }, null, 8, ["icon"])])), _createVNode(viewAllDialog, {
        "view-visible": viewVisible.value,
        "table-row": tableRow.value,
        onChangeViewVisible: changeViewVisible
      }, null, 8, ["view-visible", "table-row"])]);
    };
  }
};